import UltMeta, { Meta } from "../UltMeta";

/**
 * 文章类型
 */
class ArticleType extends UltMeta {
    ABOUT_US = new Meta(1, "关于我们");
    USER_AGREEMENT = new Meta(2, "用户协议");
    PRIVACY_AGREEMENT = new Meta(3, "隐私政策");
    MEMBER_AGREEMENT = new Meta(4, "会员服务协议");
    DEVICE_CLAIM_AGREEMENT = new Meta(5, "设备申领协议");
    INFO_SERVICE_AGREEMENT = new Meta(6, "信息服务费协议");
    CONTACT_US = new Meta(7, "联系我们");
    AI_USER_AGREEMENT = new Meta(8, "智能助理用户协议");
    AI_PRIVACY_AGREEMENT = new Meta(9, "智能助理保护规则");
    REFUELING_AGREEMENT = new Meta(10, "加油协议");
    SHIPPING_CONTRACT_SERVICE_AGREEMENT = new Meta(11, "船运合同服务协议");
}
export const ARTICLE_TYPE = new ArticleType();
class AppType extends UltMeta {
    THREE_TERMINAL = new Meta(1, "链云砂石小程序");
    CARRYING_AGREEMENT = new Meta(2, "链云船务小程序");
    PC_WEB = new Meta(3, "链云砂石PC");
    APP_LIANYUN = new Meta(4, "链云砂石APP");
    APP_CARRIER = new Meta(5, "链云船务APP");
    PC_CARRIER = new Meta(6, "链云船务PC");
}

export const APP_TYPE = new AppType();
